// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Soccer = createSvgIcon(
  { LeftToRight: <React.Fragment><g stroke="currentColor" strokeWidth="2"><circle cx="8" cy="8" r="7" /><path fill="currentColor" stroke="transparent" d="M5.902 7.5244L8.0094 6.186l2.0926 1.3384L9.4684 10H6.5496L5.902 7.5244z" /><path d="M8 6V2M6 7.5L3 6M10.0001 7.5l3-1.5M9.6842 9.6842l1.6842 2.5263M14 12l-2.5.5L10 15M6.3158 9.6842l-1.6843 2.5263M2 12l2.5.5L6 15M15 7l-2-1.5V3M1 7l2-1-.5-2.5M5.5 1.5L8 2l2.5-.5" /></g><defs></defs></React.Fragment>, },
  'small'
);
